import { useCurrentGym } from "./useCurrentGym";
import type { ModulesSettings } from "../../utils/zod/gym";

export const useModuleEnabled = (module: keyof ModulesSettings): boolean => {
  const { data: gym } = useCurrentGym();
  return gym?.modulesSettings?.[module]?.enabled ?? false;
};
